import { Promo } from 'components/promo';
const PromoContainer = Promo;
export { PromoContainer };
